import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const TextInput = /*@__PURE__*/ proxyCustomElement(class TextInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            const inputElement = this.el.querySelector('input');
            if (inputElement) {
                inputElement.value = newValue || '';
            }
        };
        this.name = undefined;
        this.label = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.maxLength = undefined;
        this.keyDownHandler = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    render() {
        return (h(Host, { key: '3450b693ae915280ba28a38613a9bd2ebb360677', exportparts: "label,input,input-invalid" }, h("div", { key: 'f815c2ff679a73375cb2d12087ecf4a2bf17d5e4', class: "form-group d-flex flex-column" }, h("div", { key: '3119c59e3f7d6b547088b1eccab66641129ec71e', class: "d-flex align-items-start gap-2" }, h("label", { key: '4e1cd66eb84cd6b3449bed5c1099627ad9ffa213', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: 'fc9bd0b06d2400a6109b93ec7c8cc7f4e8955e3b', helpText: this.helpText })), h("input", { key: '9d1d615016acd3611bee6d097ed15c3c926c5e76', id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, onKeyDown: this.keyDownHandler, onPaste: this.keyDownHandler, maxLength: this.maxLength, part: `input ${this.errorText ? "input-invalid " : ""}${this.disabled ? " input-disabled" : ""}`, class: this.errorText ? "form-control is-invalid" : "form-control", type: "text", disabled: this.disabled }), h("form-control-error-text", { key: 'ac9f44ac5411a76c8b29f00ac4bfda91f5395e71', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-text", {
        "name": [8],
        "label": [1],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "maxLength": [2, "max-length"],
        "keyDownHandler": [16],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-text", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-text":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TextInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TextInput as T, defineCustomElement as d };
